import type { ZikrSetId } from '@sayfazkari/content';

/**
 * Граница дня для стриков.
 *
 * Вечерние азкары, прочитанные в 00:30, по календарю попадают в новый день —
 * и человек теряет стрик за честно выполненное действие. Поэтому всё,
 * начатое между 00:00 и 04:00, засчитывается предыдущим днём.
 *
 * Это продуктовое решение, не техническое: по шариату день сменяется
 * с магрибом, но привязка к магрибу требует координат пользователя.
 */
const NIGHT_CUTOFF_HOUR = 4;

export function dayKey(at: Date = new Date()): string {
  const d = new Date(at);
  if (d.getHours() < NIGHT_CUTOFF_HOUR) {
    d.setDate(d.getDate() - 1);
  }
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/**
 * Какой набор уместен прямо сейчас. Пока — по фиксированным часам.
 *
 * Настоящее время азкаров привязано к фаджру и асру, а не к часам на стене.
 * Переход на расчёт по молитвам (adhan-js) требует координат — разрешение
 * геолокации, выбор города и внятная история про приватность. Это v2.
 */
export function currentSetByClock(at: Date = new Date()): ZikrSetId {
  const h = at.getHours();
  return h >= NIGHT_CUTOFF_HOUR && h < 16 ? 'morning' : 'evening';
}

/** Разница в днях между двумя ключами дня */
export function daysBetween(from: string, to: string): number {
  const a = new Date(`${from}T00:00:00`);
  const b = new Date(`${to}T00:00:00`);
  return Math.round((b.getTime() - a.getTime()) / 86_400_000);
}

export function timeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return 'UTC';
  }
}
